export default {
  dailyCheckTourEvent: {
    tableColumns: {
      procedureName: 'Procedure name',
      status: 'Status',
      alerts: 'Alerts',
    },
  },
};
